import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export const Divider = ({ className }) => {
  return (
    <div
      className={classNames(
        "tw-my-5 tw-h-px tw-border-t tw-border-solid tw-border-0 tw-border-border-primary",
        className
      )}
    />
  );
};

Divider.propTypes = {
  className: PropTypes.string,
};
